module.exports = __webpack_public_path__ + "static/media/PigGame.db815b1a.png";